// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.manage-header{
    padding: 0 7%;
    background: #FFFFFF;
}
.manage-title-img{
    height:40px ;
    width:40px ;
    cursor:pointer;
}
.org-title-name{
font-size: 24px;
font-weight: 400;
color: #424242;
}
.manage-title-type{
    font-weight: 500;
    font-size: 12px;
    color: #68AD3F;
}
.manage-title-date{
    font-weight: 400;
    font-size: 14px;
    color: #000000;
}
.single-line-title{
    display: flex;
    padding: 27px 7%;
    column-gap: 16px;
}
.title-with-btn{
    display:flex;
    justify-content:space-between;
}
.title-btn-div{
    align-self:flex-end;
}
.invisible{
    visibility:hidden;
}
@media only screen and (min-width: 0px) and (max-width: 480px) {
    .org-title-name{
        font-size: 22px;
        }
        .db-org-title{
            font-size: 20px;
        }
        .manage-title-type{
            font-size: 10px;
        }
        
        .manage-title-date{
            font-size: 12px;
        }
        .manage-header{
            padding: 0 5%;
        }
        .single-line-title{
            padding: 15px 5%;
            flex-direction:column;
        }
        .title-with-btn{
            flex-direction:column;
        }
}
@media only screen and (min-width: 481px) and (max-width: 767px) {
    .org-title-name{
        font-size: 22px;
        }
        .db-org-title{
            font-size: 20px;
        }
        .manage-title-type{
            font-size: 10px;
        }
        .manage-title-date{
            font-size: 12px;
        }
        .manage-header{
            padding: 0 5%;
        }
        .single-line-title{
            padding: 15px 5%;
            flex-direction:column;
        }
}
@media only screen and (min-width: 768px) and (max-width: 1024px) {
    .org-title-name{
        font-size: 22px;
        }
        .db-org-title{
            font-size: 20px;
        }
        .manage-header{
            padding: 0 7%;
        }
        .single-line-title{
            padding: 27px 7%;
        }
}
`, "",{"version":3,"sources":["webpack://./src/Components/TitleElements/ManageTitle.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,mBAAmB;AACvB;AACA;IACI,YAAY;IACZ,WAAW;IACX,cAAc;AAClB;AACA;AACA,eAAe;AACf,gBAAgB;AAChB,cAAc;AACd;AACA;IACI,gBAAgB;IAChB,eAAe;IACf,cAAc;AAClB;AACA;IACI,gBAAgB;IAChB,eAAe;IACf,cAAc;AAClB;AACA;IACI,aAAa;IACb,gBAAgB;IAChB,gBAAgB;AACpB;AACA;IACI,YAAY;IACZ,6BAA6B;AACjC;AACA;IACI,mBAAmB;AACvB;AACA;IACI,iBAAiB;AACrB;AACA;IACI;QACI,eAAe;QACf;QACA;YACI,eAAe;QACnB;QACA;YACI,eAAe;QACnB;;QAEA;YACI,eAAe;QACnB;QACA;YACI,aAAa;QACjB;QACA;YACI,gBAAgB;YAChB,qBAAqB;QACzB;QACA;YACI,qBAAqB;QACzB;AACR;AACA;IACI;QACI,eAAe;QACf;QACA;YACI,eAAe;QACnB;QACA;YACI,eAAe;QACnB;QACA;YACI,eAAe;QACnB;QACA;YACI,aAAa;QACjB;QACA;YACI,gBAAgB;YAChB,qBAAqB;QACzB;AACR;AACA;IACI;QACI,eAAe;QACf;QACA;YACI,eAAe;QACnB;QACA;YACI,aAAa;QACjB;QACA;YACI,gBAAgB;QACpB;AACR","sourcesContent":[".manage-header{\n    padding: 0 7%;\n    background: #FFFFFF;\n}\n.manage-title-img{\n    height:40px ;\n    width:40px ;\n    cursor:pointer;\n}\n.org-title-name{\nfont-size: 24px;\nfont-weight: 400;\ncolor: #424242;\n}\n.manage-title-type{\n    font-weight: 500;\n    font-size: 12px;\n    color: #68AD3F;\n}\n.manage-title-date{\n    font-weight: 400;\n    font-size: 14px;\n    color: #000000;\n}\n.single-line-title{\n    display: flex;\n    padding: 27px 7%;\n    column-gap: 16px;\n}\n.title-with-btn{\n    display:flex;\n    justify-content:space-between;\n}\n.title-btn-div{\n    align-self:flex-end;\n}\n.invisible{\n    visibility:hidden;\n}\n@media only screen and (min-width: 0px) and (max-width: 480px) {\n    .org-title-name{\n        font-size: 22px;\n        }\n        .db-org-title{\n            font-size: 20px;\n        }\n        .manage-title-type{\n            font-size: 10px;\n        }\n        \n        .manage-title-date{\n            font-size: 12px;\n        }\n        .manage-header{\n            padding: 0 5%;\n        }\n        .single-line-title{\n            padding: 15px 5%;\n            flex-direction:column;\n        }\n        .title-with-btn{\n            flex-direction:column;\n        }\n}\n@media only screen and (min-width: 481px) and (max-width: 767px) {\n    .org-title-name{\n        font-size: 22px;\n        }\n        .db-org-title{\n            font-size: 20px;\n        }\n        .manage-title-type{\n            font-size: 10px;\n        }\n        .manage-title-date{\n            font-size: 12px;\n        }\n        .manage-header{\n            padding: 0 5%;\n        }\n        .single-line-title{\n            padding: 15px 5%;\n            flex-direction:column;\n        }\n}\n@media only screen and (min-width: 768px) and (max-width: 1024px) {\n    .org-title-name{\n        font-size: 22px;\n        }\n        .db-org-title{\n            font-size: 20px;\n        }\n        .manage-header{\n            padding: 0 7%;\n        }\n        .single-line-title{\n            padding: 27px 7%;\n        }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
